import React, { useEffect } from "react";
import { appConfig } from "../../../../configApp";

const Gift = () => {

    useEffect(() => {
        window.location.href = appConfig?.baseUrlGift
    }, []);

    return null;
};

export default Gift;